






























































































































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { localGet, setMetaData, timeFormat, downloadFile } from "@/utils";
import { setCommon, errorMsg, setPage, handleResponse } from "@/utils/request";
import { pagnition } from "@/utils/commonConfig";

@Component({
  name: "PSPerformanceList",
  components: {},
})
export default class CombinationProperty extends Vue {
  @Provide() private ruleForm: any = {
    Statstype: "",
    Email: "",
    Username: "",
    Usergroupid: "",
    Itemid: "",
    Timerange: "",
    Employeeid: "",
  };
  @Provide() private issearchDone: boolean = false;
  @Provide() private issearchByday: boolean = false;
  @Provide() private byDayDisplay: boolean = false;
  @Provide() private downLoadDone: boolean = false;
  // 角色
  @Provide() private roleData: any = [];
  @Provide() private execType: number | null = null; //角色

  @Provide() private updatatime: string = "20";
  @Provide() private employId: string = "";
  @Provide() private resultData: any = [];
  @Provide() private pagnition: any = pagnition; // lee 分页参数
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private sortCondition: any = {
    prop: null,
    order: null,
  };
  @Provide() private parameterData: any = [
    { id: 100, name: "PV" },
    { id: 107, name: "CPV" },
    { id: 101, name: "IR" },
    { id: 102, name: "QI" },
  ]; //审核类型
  @Provide() private StatstypeData: any = []; //角色
  private created() {
    this.StatstypeData = [
      { id: 103, name: "Confirm Loan" },
      { id: 104, name: "Recall" },
    ];
    this.getRoleList();
  }
  private params() {
    let _arg: any = {
      Statstype: this.ruleForm.Statstype,
      Email: this.ruleForm.Email,
      Username: this.ruleForm.Username,
      Employeeid: this.ruleForm.Employeeid,
      Usergroupid: this.ruleForm.Usergroupid,
      Itemid: this.ruleForm.Itemid,
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      prop: this.sortCondition.prop,
      order: this.sortCondition.order,
    };
    if (
      this.ruleForm.Timerange &&
      this.ruleForm.Timerange.length > 0 &&
      this.ruleForm.Timerange[0]
    ) {
      // 开始时间 - 结束时间
      _arg.Timerange =
        timeFormat(this.ruleForm.Timerange[0]) +
        " - " +
        timeFormat(this.ruleForm.Timerange[1]);
    }
    console.log(_arg, "_arg");
    return _arg;
  }
  //  private addButton() {
  //   this.isDateButton = true;
  // }
  //  处理 日期时间选择操作
  private pickerAction(val: any) {
    console.log(val, "picked");
    return;
    // if (!val) {
      // this.pickTime = null;
      // return;
    // }
    let opt = val;
    var _maxDate = null; //初始化
    var _maxTime = null; //初始化
    let _minDate = new Date(opt[0]);
    let _minTime = _minDate.getFullYear() + _minDate.getMonth() + _minDate.getDate();
    _maxDate = new Date(opt[1]);
    _maxTime = _maxDate.getFullYear() + _maxDate.getMonth() + _maxDate.getDate();
  }
  //获取列表数据
  private async getIlstData() {
    if (!this.ruleForm.Timerange || this.ruleForm.Timerange.length < 2) {
      this.issearchDone = false;
      this.$message({
        type: "warning",
        message: `${this.$t("tipsWrh.enterChooseTime")}`,
      });
      return;
    }
    const { getListPhoneSaleStatsReq, getListPhoneSaleStatsRequest }: any = await import(
      "@/request/phoneSaleDataModule"
    );
    let res = await getListPhoneSaleStatsRequest.handleHttp(
      getListPhoneSaleStatsReq(this.params()),
      this
    );
    if (res && res.right) {
      console.log(res, "getListPhoneSaleStatsReq");
      this.resultData = res.listList;
      this.pagerCount = res.pageout.total;
    } else {
    }
    this.issearchDone = false;
    this.issearchByday = false;
    this.resultData.forEach((item: any) => {
      item.attendanceat = item.attendanceat && timeFormat(item.attendanceat);
    });
  }
  getIlst(index: number) {
    this.ruleForm.Statstype = index;
    if (index == 2) {
      this.issearchByday = true;
      this.byDayDisplay = true;
    } else {
      this.issearchDone = true;
      this.byDayDisplay = false;
    }
    this.getIlstData();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getIlstData();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getIlstData();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getIlstData();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getIlstData();
  }
  private async getRoleList() {
    let _arg: any = {
      execType: "7", //sessionStorage.getItem("exectype"),
    };
    const {
      setListUserGroupByTypeReq,
      getListUserGroupByTypeRequest,
    }: any = await import("@/request/staffManagement");
    let res = await getListUserGroupByTypeRequest.handleHttp(
      setListUserGroupByTypeReq(_arg),
      null
    );
    if (res && res.right) {
      console.log(res, "getUserListRequest");
      if (res.usergroupinfosList && res.usergroupinfosList.length > 0) {
        this.roleData = res.usergroupinfosList;
      } else {
        this.roleData = [];
      }
    } else {
      this.$message.error(res.commonout.errmsg);
    }
  }
  //  lee 导出操作
  private async exportFormAction(index: number) {
    this.ruleForm.Statstype = index;
    if (!this.ruleForm.Timerange || this.ruleForm.Timerange.length < 2) {
      this.issearchDone = false;
      this.$message({
        type: "warning",
        message: `${this.$t("tipsWrh.enterChooseTime")}`,
      });
      return;
    }
    let arg = this.params();
    const { getListPhoneSaleStatsExcelReq }: any = await import(
      "@/request/phoneSaleDataModule"
    );
    let res = await getListPhoneSaleStatsExcelReq(arg, this);
    // if (response) {
    console.log(res, res.array[3], "exportFormAction");
    //   if ((response.array[3] && response, response.array[3].length > 0)) {
    //     const blob = new Blob([response.array[3]], {
    //       type: "application/vnd.ms-excel;charset=utf-8",
    //     });
    //     downloadFile(blob, response.array[2]);
    //   }
    // }
    if (res?.array[0] && res?.array[0][0] === 2) {
      // 服务器错误
      this.$message({
        message: "DError, please contact admin!",
        type: "error",
      });
    } else if (res?.array[0] && res?.array[0][0] === 5) {
      // 没有文件
      this.$message({
        message: "Downloading, please click the export button again after 5 minutes!",
        type: "warning",
      });
    } else if (res && res.array[3]) {
      console.log(res, "exportFormAction");
      if (res.array[3] && res.array[3].length && res.array[3]?.length > 0) {
        const blob = new Blob([res.array[3]], {
          type: "octet/stream",
        });
        downloadFile(blob, res.array[2]);
      }
    }
  }

  private sortChange(val: any) {
    switch (val.prop) {
      case "passrate":
        this.sortCondition.prop = 24;
        break;
      case "invalidrate":
        this.sortCondition.prop = 25;
        break;
      case "rejectrate":
        this.sortCondition.prop = 26;
        break;
    }
    switch (val.order) {
      case "descending":
        this.sortCondition.order = 2;
        break;
      case "ascending":
        this.sortCondition.order = 1;
        break;
      default:
        this.sortCondition.order = 2;
        break;
    }
    this.getIlstData();
  }
}
